/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_4_DescInputs */

const en_mk_cap_4_desc = /** @type {(inputs: Mk_Cap_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One box to jump to a page, find an issue or run a command. Single-letter shortcuts for the things you do often.`)
};

const id_mk_cap_4_desc = /** @type {(inputs: Mk_Cap_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu kotak untuk melompat ke halaman, mencari issue, atau menjalankan perintah. Ada pintasan huruf untuk yang sering.`)
};

/**
* | output |
* | --- |
* | "One box to jump to a page, find an issue or run a command. Single-letter shortcuts for the things you do often." |
*
* @param {Mk_Cap_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_4_desc = /** @type {((inputs?: Mk_Cap_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_4_desc(inputs)
	return en_mk_cap_4_desc(inputs)
});